/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionsend1Inputs */

const en_actionsend1 = /** @type {(inputs: Actionsend1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send action`)
};

const de_actionsend1 = /** @type {(inputs: Actionsend1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktion schalten`)
};

/**
* | output |
* | --- |
* | "Send action" |
*
* @param {Actionsend1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionsend1 = /** @type {((inputs?: Actionsend1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionsend1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionsend1(inputs)
	return de_actionsend1(inputs)
});
export { actionsend1 as "actionSend" }